import { OpCoData } from '../../models';

import { UseContentSelector } from './UseContentSelector.ts';

export const OpCoListContent: UseContentSelector<Array<OpCoData>, Array<OpCoData>> = {
  useResultSelector: (content) => content.opcos,
  useDataSelector: (opcos) => opcos,
};
